import React, { useContext } from 'react';
import { useQuery } from '@apollo/client';
import { Header, Grid } from 'semantic-ui-react';
import momentTZ from 'moment-timezone';
import { LIST } from '../../queries/list';
import ListName from './ListName';
import ShareListButton from './ShareListButton';
import FollowListButton from './FollowListButton';
import InviteAllButton from './InviteAllButton';
import ExpertCards from './ExpertCards';
import ExpertCardsWithWizaControls from './ExpertCardsWithWizaControls';
import Loading from '../Loading';
import DataContext from '../../contexts/DataContext';
import Security from '../../utils/Security';

const ListExperts = ({ id }) => {
  const { user } = useContext(DataContext);
  const { loading, data, error } = useQuery(LIST, {
    variables: { id },
  });

  const list = data?.list;
  const experts = list?.experts || [];
  const isSuperUser = Security.isSuperUser(user);

  if (loading) return (<Loading />);
  if (error) return (<Header>List is not available</Header>);

  const timeFormat = 'MM/DD/YYYY';
  const updatedAt = momentTZ.tz(list.updatedAt, user.timeZone).format(timeFormat);

  return (
    <div id="list-experts">
      <Grid stackable>
        <Grid.Row columns={2}>
          <Grid.Column>
            <ListName list={data.list} />
            <Header.Subheader>
              {list.user.id !== user.id && `By ${list.user.fullName} of ${list.user.membership[0].teamName} - `}
              {`Updated ${updatedAt}`}
            </Header.Subheader>
          </Grid.Column>
          <Grid.Column textAlign="right">
            {list.name !== 'Favorites' && user.id === list.user.id && (
              <ShareListButton list={data.list} />
            )}
            {user.id !== list.user.id && (
              <FollowListButton list={data.list} />
            )}
            <InviteAllButton list={data.list} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {isSuperUser ? (
        <ExpertCardsWithWizaControls key={id} experts={experts} />
      ) : (
        <ExpertCards experts={experts} />
      )}
    </div>
  );
};

export default ListExperts;
